/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-05-08 09:53:41
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-31 16:59:08
 * @FilePath: \合联\oms\src\utils\mixin.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { newCustomZhCn, transforms } from '@/locale/index'
export default function setup(Vue) {
	Vue.mixin({
		mounted() {
		},
		methods: {
			setOptions(origin, key, options) {
				if (typeof key === 'string') {
					origin.find(t => {
						if (t.key === key) {
							t.options = options
						}
					})
				} else {
					Object.keys(key).forEach(t => {
						origin.forEach(o => {
							if (o.key === t) {
								o.options = key[t]
							}
						})
					})
				}
			},
			$tz(key, t1, t2, t3) {
				let isTrue = false
				let k = key
				if (!k) return
				if (!Array.isArray(k)) {
					k += ''
					k = k.split(',')
					k = k.reduce((a, b) => {
						if (transforms[b]) {
							a = a.concat(transforms[b].split(','))
						} else a.push(b)
						return a
					}, [])
				}
				let text = k.map((c, i) => {
					let key = newCustomZhCn[c]
					if (key) isTrue = true
					return key ? (this.$t && this.$t(key)) + (this.$i18n && this.$i18n.locale === 'en-US' && i !== k.length - 1 ? ' ' : '') : (process.env.NODE_ENV === 'development' ? '__' : '') + c
				}).join('').replace('{1}', this.$tz(t1)).replace('{2}', this.$tz(t2)).replace('{3}', this.$tz(t3)) || k.join('').replace('{1}', this.$tz(t1)).replace('{2}', this.$tz(t2)).replace('{3}', this.$tz(t3))
				if (isTrue) return text
				else {
					return (process.env.NODE_ENV === 'development' ? '__' : '') + key
				}
			}
		}
	})
}